<template>
    <div>
        <el-upload class="upload-demo" action="https://interface.luchuaner.com/danzhangtihuan" :data="{ id: tihuanitem.id }"
            :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" accept="image/*">
            <el-button v-if="type==1" size="mini" style="padding:8px 15px;margin-right: 10px;" type="" :loading="loading">替换</el-button>
            <el-button v-if="type==2" size="mini" style="background: #cccccc;width:100px;margin-right: 10px;" type="" :loading="loading">替换图片</el-button>
        </el-upload>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false
        }
    },
    props: {
        tihuanitem: Object,
        gengxintupianxinxi:Function,
        type:Number
    },
    methods: {
        handleAvatarSuccess(res, file) {
            //  this.imageUrl = URL.createObjectURL(file.raw);
            this.loading = false
            this.$notify({
                title: '替换图片',
                message: '替换成功',
                type: 'success'
            });
            this.$set(this.tihuanitem,'300_path',res.data['300_path'])
            this.$set(this.tihuanitem,'file_size',res.data['file_size'])
            this.$set(this.tihuanitem,'600_path',res.data['600_path'])
            this.$set(this.tihuanitem,'original_path',res.data['original_path'])
            this.$set(this.tihuanitem,'1600_path',res.data['1600_path'])
            this.$set(this.tihuanitem,'file_name',res.data['file_name'])
            this.$set(this.tihuanitem,'width',res.data['width'])
            this.$set(this.tihuanitem,'height',res.data['height'])
            this.$set(this.tihuanitem,'file_time',res.data['file_time'])
            if(this.tihuanitem.iscover==1){
                  this.gengxintupianxinxi(this.tihuanitem,3)
            }

        },
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 15;
            if (!isLt2M) {
                this.$message.error('图片大小不能超过 15MB!');
            } else {
                this.loading = true
            }

            return isLt2M;
        }
    }
}
</script>

<style></style>